// Função global para inicializar vídeos nos product cards
function initializeVideoCards() {
  // Aguardar um pouco para garantir que o DOM foi atualizado
  setTimeout(function() {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach(function(card) {
      // Verificar se o card já foi processado
      if (card.hasAttribute('data-video-initialized')) {
        return;
      }
      
      // Marcar como inicializado
      card.setAttribute('data-video-initialized', 'true');
      
      // Verificar se tem vídeo (lógica similar ao product-card.liquid)
      const videoContainer = card.querySelector('.product-card__video-container');
      if (videoContainer) {
        const video = videoContainer.querySelector('video');
        if (video) {
          // Garantir que o vídeo tenha os atributos corretos
          video.setAttribute('autoplay', '');
          video.setAttribute('muted', '');
          video.setAttribute('loop', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('preload', 'metadata');
          video.setAttribute('draggable', 'false');
          
          // Tentar carregar o vídeo
          video.load();
        }
      }
    });
  }, 100);
}

// Inicializar vídeos quando a página carrega
document.addEventListener('DOMContentLoaded', function() {
  initializeVideoCards();
});

// Re-executar quando filtros são aplicados
document.addEventListener('facet:update', function() {
  // Aguardar o conteúdo ser atualizado
  setTimeout(function() {
    initializeVideoCards();
  }, 500);
});

// Inicializar vídeos quando a página carrega
document.addEventListener('DOMContentLoaded', function() {
  initializeVideoCards();
});

function change_card_colors(input, event) {
  event.preventDefault();    
  var newImageUrl = input.getAttribute('data-image');
  var newSecondaryImageUrl = input.getAttribute('data-secondary');
  var newTitle = input.getAttribute('data-title');
  var newLink = input.getAttribute('data-link');
  var selectedVariantId = input.getAttribute('data-variant-id');
  var newProductId = input.getAttribute('data-product-id');
  var newPrice = input.getAttribute('data-price');

  if (!newImageUrl) return;
  
  var productCard = input.closest('.product-card');
  if (!productCard) return;
  
  // Verificar se é um card de vídeo e converter para slider
  var videoContainer = productCard.querySelector('.product-card__video-container');
  if (videoContainer) {
    console.log('Converting video card to image slider');
    convertVideoCardToSlider(productCard, videoContainer);
  }
  
  var primaryImage = productCard.querySelector('.product-card__image--primary');
  if (primaryImage) {
    primaryImage.src = newImageUrl;
    primaryImage.setAttribute('src', newImageUrl);
    if(primaryImage.hasAttribute('data-src')) {
      primaryImage.setAttribute('data-src', newImageUrl);
    }
    if(primaryImage.hasAttribute('srcset')) {
      primaryImage.setAttribute('srcset', newImageUrl);
    }
  }
  
  var secondaryImage = productCard.querySelector('.product-card__image--secondary');
  if (secondaryImage && newSecondaryImageUrl) {
    secondaryImage.src = newSecondaryImageUrl;
    secondaryImage.setAttribute('src', newSecondaryImageUrl);
    if(secondaryImage.hasAttribute('data-src')) {
      secondaryImage.setAttribute('data-src', newSecondaryImageUrl);
    }
    if(secondaryImage.hasAttribute('srcset')) {
      secondaryImage.setAttribute('srcset', newSecondaryImageUrl);
    }
  }
  
  var productTitle = productCard.querySelector('.product-title');
  if (productTitle && newTitle) {
    productTitle.textContent = newTitle;
    if(newLink) {
      productTitle.href = newLink;
    }
  }
  
  var productPrice = productCard.querySelector('.product-price');
  if (productPrice && newPrice) {
    productPrice.textContent = newPrice;
  }
  
  if(newLink) {
    var mediaLink = productCard.querySelector('.product-card__media');
    if(mediaLink) {
      mediaLink.href = newLink;
    }
  }
  
  // Recarregar Swiper se existir e houver novas imagens
  var swiperContainer = productCard.querySelector('.product-card__swiper');
  console.log('Swiper container found:', !!swiperContainer);
  
  if (swiperContainer) {
    try {
      // Obter todas as imagens do produto
      var productImages = input.getAttribute('data-images');
      var images = [];
      
      if (productImages) {
        try {
          images = JSON.parse(productImages);
          console.log('Product images loaded:', images.length);
        } catch (e) {
          console.error('Error parsing product images:', e);
          // Fallback para imagens individuais
          if (newImageUrl) {
            images.push({ url: newImageUrl, alt: newTitle });
          }
          if (newSecondaryImageUrl) {
            images.push({ url: newSecondaryImageUrl, alt: newTitle });
          }
        }
      } else {
        // Fallback para imagens individuais
        if (newImageUrl) {
          images.push({ url: newImageUrl, alt: newTitle });
        }
        if (newSecondaryImageUrl) {
          images.push({ url: newSecondaryImageUrl, alt: newTitle });
        }
      }
      
      console.log('Images to update:', images.length);
      if (images.length > 0) {
        // Destruir Swiper existente se houver
        if (swiperContainer.swiper) {
          swiperContainer.swiper.destroy(true, true);
        }
        
        // Recriar slides com novas imagens
        var swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
        if (swiperWrapper) {
          swiperWrapper.innerHTML = '';
          
          images.forEach(function(image, index) {
            var slide = document.createElement('div');
            slide.className = 'swiper-slide';
            
            // Não criar link dentro do slide, pois o slide já está dentro de um link
            var img = document.createElement('img');
            img.src = image.url;
            img.alt = image.alt || newTitle;
            img.className = 'product-card__image';
            
            // Adicionar classes de aspect ratio se existirem no card original
            var originalImage = productCard.querySelector('.product-card__image');
            if (originalImage) {
              var aspectClasses = originalImage.className.match(/aspect-\w+/g);
              if (aspectClasses) {
                aspectClasses.forEach(function(cls) {
                  img.className += ' ' + cls;
                });
              }
              
              // Adicionar object-cover se existir
              if (originalImage.className.includes('object-cover')) {
                img.className += ' object-cover';
              }
            }
            
            if (index === 0) {
              img.className += ' product-card__image--primary';
            }
            img.setAttribute('draggable', 'false');
            
            slide.appendChild(img);
            swiperWrapper.appendChild(slide);
          });
          
          // Reinicializar Swiper
          setTimeout(function() {
            console.log('Reinitializing Swiper with', images.length, 'images');
            
            // Verificar se Swiper está disponível
            if (typeof Swiper === 'undefined') {
              console.error('Swiper library not loaded');
              return;
            }
            
            var newSwiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              allowTouchMove: true,
              grabCursor: true,
              navigation: {
                nextEl: swiperContainer.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.querySelector('.swiper-button-prev'),
              },
              pagination: {
                el: swiperContainer.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
              },
              breakpoints: {
                768: {
                  allowTouchMove: true,
                  grabCursor: true,
                }
              },
              on: {
                init: function() {
                  console.log('Swiper initialized successfully');
                }
              }
            });
            
            // Armazenar referência do Swiper
            swiperContainer.swiper = newSwiper;
            console.log('Swiper reinitialized successfully');
          }, 100);
        }
      }
    } catch (e) {
      console.error('Error updating Swiper with new images:', e);
    }
  }
  
  var swatchWrapper = input.closest('.color_swatches--wrapper');
  if (swatchWrapper) {
    var allSwatches = swatchWrapper.querySelectorAll('.custom-swatch');
    allSwatches.forEach(function(item) {
      item.classList.remove('checked');
    });
  }
  input.classList.add('checked');

  var variantData = input.getAttribute('data-variants');
  if (variantData) {
    try {
      var variants = JSON.parse(variantData);
      var variantContainer = productCard.querySelector('.product-card__variant-container');
      if (variantContainer) {
        var html = '<div class="variant-box"><ul class="variant-list">';
        variants.forEach(function(variant) {
          html += '<li data-color="' + (variant.option1 ? variant.option1.toLowerCase() : '') + '">';
          html += '<product-form>';
          html += '<form method="post" action="/cart/add" id="product-form-main-' + newProductId + '-' + variant.id + '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">';
          html += '<input type="hidden" name="form_type" value="product">';
          html += '<input type="hidden" name="utf8" value="✓">';
          html += '<input type="hidden" name="id" value="' + variant.id + '">';
          html += '<button type="submit" class="variant-item ' + (variant.available ? 'available' : 'unavailable') + '" ' + (variant.available ? '' : 'disabled') + '>';
          html += variant.title;
          html += '</button>';
          html += '</form>';
          html += '</product-form>';
          html += '</li>';
        });
        html += '</ul></div>';
        variantContainer.innerHTML = html;
      }
    } catch (e) {
      console.error('Error al parsear las variantes:', e);
    }
  }
}

function change_shop_the_look_colors(input, event) {
  event.preventDefault();
  var newImageUrl = input.getAttribute('data-image');
  var newSecondaryImageUrl = input.getAttribute('data-secondary');
  var newTitle = input.getAttribute('data-title');
  var newLink = input.getAttribute('data-link');
  var selectedVariantId = input.getAttribute('data-variant-id');
  var newPrice = input.getAttribute('data-price');
  var variantData = input.getAttribute('data-variants');
  if (!newImageUrl) return;
  var productRow = input.closest('.quick-buy-product-row');
  if (!productRow) return;
  var primaryImage = productRow.querySelector('.quick-buy-product__image img');
  if (primaryImage) {
    primaryImage.src = newImageUrl;
    if (primaryImage.hasAttribute('srcset')) primaryImage.srcset = newImageUrl;
  }
  var secondaryImage = productRow.querySelector('.product-card__image--secondary');
  if (secondaryImage && newSecondaryImageUrl) {
    secondaryImage.src = newSecondaryImageUrl;
    if (secondaryImage.hasAttribute('srcset')) secondaryImage.srcset = newSecondaryImageUrl;
  }
  var productTitle = productRow.querySelector('.product-title');
  if (productTitle && newTitle) {
    productTitle.textContent = newTitle;
    if (newLink) productTitle.href = newLink;
  }
  var productPrice = productRow.querySelector('.product-price');
  if (productPrice && newPrice) productPrice.textContent = newPrice;
  var swatchWrapper = input.closest('.color_swatches--wrapper');
  if (swatchWrapper) {
    swatchWrapper.querySelectorAll('.custom-swatch').forEach(function(s) {
      s.classList.remove('checked');
    });
  }
  input.classList.add('checked');
  var hiddenInput = productRow.querySelector('input[type="hidden"][name$="[id]"]');
  if (hiddenInput && selectedVariantId) hiddenInput.value = selectedVariantId;
  var optsContainer = productRow.querySelector('.modal-product--variant-options');
  if (optsContainer) optsContainer.innerHTML = '';
  var oldOnlyBtn = productRow.querySelector('.modal-product--variant-only-option');
  if (oldOnlyBtn) oldOnlyBtn.remove();
  if (!variantData) return;
  var variants;
  try {
    variants = JSON.parse(variantData);
  } catch (err) {
    console.error(err);
    return;
  }
  var firstAvailable = variants.findIndex(function(v) { return v.available; });
  if (variants.length > 1 && optsContainer) {
    variants.forEach(function(variant, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'modal-product--variant-option-button';
      btn.textContent = variant.title;
      btn.dataset.variantId = variant.id;
      if (!variant.available) {
        btn.disabled = true;
        btn.style.color = 'rgba(28, 27, 27, 0.35)';
      }
      if (idx === firstAvailable && variant.available) {
        btn.classList.add('active');
        hiddenInput.value = variant.id;
      }
      btn.addEventListener('click', function() {
        optsContainer.querySelectorAll('.modal-product--variant-option-button').forEach(function(b) {
          b.classList.remove('active');
        });
        if (variant.available) {
          btn.classList.add('active');
          hiddenInput.value = variant.id;
        }
        updateShopAllButtonState();
      });
      optsContainer.appendChild(btn);
    });
  } else if (variants.length === 1) {
    var single = variants[0];
    hiddenInput.value = single.id;
    var onlyBtn = document.createElement('button');
    onlyBtn.type = 'button';
    onlyBtn.className = 'modal-product--variant-only-option';
    onlyBtn.textContent = single.title;
    onlyBtn.dataset.variantId = single.id;
    if (!single.available) {
      onlyBtn.disabled = true;
      onlyBtn.style.color = 'rgba(28, 27, 27, 0.35)';
      onlyBtn.style.borderBottom = 'none';
    } else {
      onlyBtn.classList.add('active');
    }
    onlyBtn.addEventListener('click', function() {
      if (single.available) {
        hiddenInput.value = single.id;
      }
      updateShopAllButtonState();
    });
    hiddenInput.insertAdjacentElement('afterend', onlyBtn);
  }
  updateShopAllButtonState();
}

function updateShopAllButtonState() {
  var disable = false;
  document.querySelectorAll('.quick-buy-product-row').forEach(function(row) {
    var hid = row.querySelector('input[type="hidden"][name$="[id]"]');
    if (hid) {
      var id = hid.value;
      var btn = row.querySelector('.modal-product--variant-option-button[data-variant-id="' + id + '"]') ||
                row.querySelector('.modal-product--variant-only-option[data-variant-id="' + id + '"]');
      if (btn && btn.disabled) disable = true;
    }
  });
  var shopAll = document.querySelector('.shop-all-modal-button');
  if (shopAll) shopAll.disabled = disable;
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      change_shop_the_look_colors(swatch, e);
    });
  });
  var form = document.getElementById('add-all-form');
  if (!form) return;
  updateShopAllButtonState();
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var formData = new FormData(form);
    var itemCount = parseInt(form.getAttribute('data-item-count'), 10);
    var items = [];
    for (var i = 0; i < itemCount; i++) {
      var id = formData.get('items[' + i + '][id]');
      var quantity = formData.get('items[' + i + '][quantity]');
      if (id) {
        items.push({
          id: parseInt(id, 10),
          quantity: quantity ? parseInt(quantity, 10) : 1
        });
      }
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function(response) {
      if (!response.ok) throw new Error('Error al añadir productos al carrito');
      return response.json();
    }).then(function(data) {
      var modal = document.getElementById('shop-the-look-quick-buy-modal');
      if (modal) {
        modal.close();
        document.body.style.overflow = '';
      }
    }).catch(function(error) {
      console.error(error);
    });
  });
});

// ============================================================================
//  APP ORBE
// ============================================================================

function cleanUrl(url) {
  try {
    const urlObj = new URL(url);
    const cleanParams = new URLSearchParams();
    
    for (const [key, value] of urlObj.searchParams.entries()) {
      if (key === 'country') {
        cleanParams.set(key, value);
      } else if (key !== 'country' || !cleanParams.has('country')) {
        cleanParams.set(key, value);
      }
    }
    
    const cleanUrl = urlObj.origin + urlObj.pathname;
    const queryString = cleanParams.toString();
    
    return queryString ? cleanUrl + '?' + queryString : cleanUrl;
  } catch (e) {
    console.error('Erro ao limpar URL:', e);
    return url;
  }
}

function setOrbeCookies(countryCode, languageCode) {
  try {
    let shopDomain = (typeof orbito !== 'undefined' && orbito.getCountryDomain) 
      ? (orbito.getCountryDomain() || window.location.hostname.replace(/^www\./, '')) 
      : window.location.hostname.replace(/^www\./, '');
    
    if (countryCode) {
      document.cookie = `mdApp_countryCodeDomain=${countryCode}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60}; SameSite=Lax`;
      console.log(`Cookie Orbe definido: mdApp_countryCodeDomain=${countryCode}`);
    }
    
    if (languageCode) {
      document.cookie = `mdApp_showRecommendationLang=${languageCode}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60}; SameSite=Lax`;
      console.log(`Cookie Orbe definido: mdApp_showRecommendationLang=${languageCode}`);
    }
  } catch (e) {
    console.error('Erro ao definir cookies do Orbe:', e);
  }
}

function handleLocalizationChange(event, type, value) {
  event.preventDefault();
  
  try {
    const form = event.target.closest('form');
    if (!form) {
      console.error('Formulário não encontrado');
      return;
    }
    
    
    const currentUrl = window.location.href;
    const cleanCurrentUrl = cleanUrl(currentUrl);
    
  
    let newUrl;
    if (type === 'country_code') {
     
      const urlObj = new URL(cleanCurrentUrl);
      urlObj.searchParams.set('country', value);
      newUrl = urlObj.toString();
      
   
      setOrbeCookies(value, null);
      
      console.log(`País alterado para: ${value}`);
      console.log(`Nova URL: ${newUrl}`);
      
    } else if (type === 'locale_code') {
     
      newUrl = cleanCurrentUrl;
      
      setOrbeCookies(null, value);
      
      console.log(`Idioma alterado para: ${value}`);
    }
    
    setTimeout(() => {
 
      if (newUrl && newUrl !== currentUrl) {
        window.location.href = newUrl;
      } else {
      
        window.location.reload();
      }
    }, 100);
    
  } catch (e) {
    console.error('Erro ao processar mudança de localização:', e);

    window.location.reload();
  }
}


function initializeLocalizationSelectors() {
  try {
   
    setTimeout(() => {
      const countrySelectors = document.querySelectorAll('button[name="country_code"]');
      const languageSelectors = document.querySelectorAll('button[name="locale_code"]');
      
      
      countrySelectors.forEach(selector => {
        if (!selector.hasAttribute('data-localization-initialized')) {
          selector.setAttribute('data-localization-initialized', 'true');
          selector.addEventListener('click', (e) => {
            handleLocalizationChange(e, 'country_code', selector.value);
          });
          console.log(`Seletor de país inicializado: ${selector.value}`);
        }
      });
      
   
      languageSelectors.forEach(selector => {
        if (!selector.hasAttribute('data-localization-initialized')) {
          selector.setAttribute('data-localization-initialized', 'true');
          selector.addEventListener('click', (e) => {
            handleLocalizationChange(e, 'locale_code', selector.value);
          });
          console.log(`Seletor de idioma inicializado: ${selector.value}`);
        }
      });
      
      console.log(`Inicializados: ${countrySelectors.length} seletores de país, ${languageSelectors.length} seletores de idioma`);
    }, 500);
    
  } catch (e) {
    console.error('Erro ao inicializar seletores de localização:', e);
  }
}


document.addEventListener('DOMContentLoaded', function() {
  initializeLocalizationSelectors();
});


document.addEventListener('facet:update', function() {
  setTimeout(initializeLocalizationSelectors, 500);
});


if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    let shouldReinitialize = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.querySelector('button[name="country_code"]') || 
            node.querySelector('button[name="locale_code"]')
          )) {
            shouldReinitialize = true;
          }
        });
      }
    });
    
    if (shouldReinitialize) {
      setTimeout(initializeLocalizationSelectors, 200);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// ============================================================================
// CARD VÍDEO PARA SLIDER DE IMAGENS
// ============================================================================
function convertVideoCardToSlider(productCard, videoContainer) {
  try {
    // Encontrar o container pai do vídeo
    var mediaLink = videoContainer.closest('.product-card__media');
    if (!mediaLink) return;
    
    // Criar estrutura do Swiper
    var swiperHTML = `
      <div class="product-card__swiper swiper">
        <div class="swiper-wrapper">
          <!-- Slides serão adicionados dinamicamente -->
        </div>
        <div class="swiper-pagination"></div>
        <button class="swiper-button-prev" aria-label="Previous image"></button>
        <button class="swiper-button-next" aria-label="Next image"></button>
      </div>
    `;
    
    // Substituir o vídeo pelo Swiper
    mediaLink.innerHTML = swiperHTML;
    
    // Adicionar estilos básicos para o Swiper
    var style = document.createElement('style');
    style.textContent = `
      .product-card__swiper {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .product-card__swiper .swiper-slide {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .product-card__swiper .product-card__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .product-card__swiper .swiper-pagination {
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
      }
      .product-card__swiper .swiper-button-prev,
      .product-card__swiper .swiper-button-next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        width: 30px;
        height: 30px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        border: none;
        cursor: pointer;
      }
      .product-card__swiper .swiper-button-prev {
        left: 10px;
      }
      .product-card__swiper .swiper-button-next {
        right: 10px;
      }
    `;
    document.head.appendChild(style);
    
    // Adicionar classe para indicar que foi convertido
    productCard.classList.add('video-converted-to-slider');
    
    console.log('Video card converted to slider structure');
    
  } catch (e) {
    console.error('Error converting video card to slider:', e);
  }
}

// ============================================================================
// FIN  APP ORBE
// ============================================================================
 


// ============================================================================
//   COUNTDOWN HEADER APP
// ============================================================================
setTimeout(() => {
const countdownWrapper = document.querySelector('.essential_countdown_annoucement_bar_wrapper')
const heightObserver = document.querySelector('header')

if (countdownWrapper && heightObserver) {
  heightObserver.classList.add('essential_countdown_active')
}
}, 1500)


let countdownTimerInterval = null;

function cloneCountdownTimer() {
  const sourceDiv = document.querySelector('.cart-drawer__announcement-app-fake');
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (sourceDiv && cartDrawer) {
    const targetDiv = cartDrawer.querySelector('.cart-drawer__announcement-app');
    if (targetDiv) {
      targetDiv.innerHTML = sourceDiv.innerHTML;
    }
  }
}

function startCountdownTimerSync() {
  if (countdownTimerInterval) {
    clearInterval(countdownTimerInterval);
  }
  
  cloneCountdownTimer();
  
  countdownTimerInterval = setInterval(function() {
    cloneCountdownTimer();
  }, 1000);
}

function stopCountdownTimerSync() {
  if (countdownTimerInterval) {
    clearInterval(countdownTimerInterval);
    countdownTimerInterval = null;
  }
}

document.addEventListener('cart:change', function() {
  setTimeout(startCountdownTimerSync, 150);
});

document.addEventListener('cart-drawer:refreshed', function() {
  setTimeout(startCountdownTimerSync, 150);
});

document.addEventListener('cart:refresh', function() {
  setTimeout(startCountdownTimerSync, 250);
});

function setupCartDrawerListeners() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('dialog:after-close', stopCountdownTimerSync);
    cartDrawer.addEventListener('dialog:close', stopCountdownTimerSync);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupCartDrawerListeners);
} else {
  setupCartDrawerListeners();
}

// ============================================================================
//  FIN COUNTDOWN HEADER APP
// ============================================================================